import React from 'react';
import { Modal, Table, Tag } from 'antd';
import { CrownOutlined } from '@ant-design/icons';

const MedalWinnersModal = ({
    visible,
    onCancel,
    medalWinners,
    gradingFinished,
}) => {
    // Transform data: Group winners by event and medal  
    const eventMedalists = {};

    if (medalWinners && medalWinners.length > 0) {
        medalWinners.forEach((winner) => {
            const eventName = winner.event.name;
            const eventStyle = winner.event.style;
            const eventKey = `${eventName} / ${eventStyle}`;

            if (!eventMedalists[eventKey]) {
                eventMedalists[eventKey] = {
                    key: eventKey,
                    eventName,
                    eventStyle,
                    gold: [],
                    silver: [],
                    bronze: [],
                };
            }

            const medalType = winner.medal.toLowerCase(); // 'gold', 'silver', 'bronze'  

            // Get participant names  
            let contestantNames =
                winner.contestantName ||
                (winner.contestants
                    ? winner.contestants.map(
                        (contestant) =>
                            `${contestant.first_name} ${contestant.last_name}`
                    )
                    : ['No Contestants']);

            if (!Array.isArray(contestantNames)) {
                contestantNames = [contestantNames];
            }

            // Add participant names to the corresponding medal array  
            if (
                medalType === 'gold' ||
                medalType === 'silver' ||
                medalType === 'bronze'
            ) {
                eventMedalists[eventKey][medalType].push(...contestantNames);
            }
        });
    }

    // Prepare data for the table  
    const dataSource = Object.values(eventMedalists);

    const columns = [
        {
            title: 'Event Name / Style',
            dataIndex: 'eventName',
            key: 'eventName',
            render: (text, record) => `${record.eventName} / ${record.eventStyle}`,
        },
        {
            title: (
                <Tag color='darkorange'>
                    Gold
                    <CrownOutlined style={{ marginLeft: 8, color: 'white' }} />
                </Tag>
            ),
            dataIndex: 'gold',
            key: 'gold',
            render: (gold) => (gold.length > 0 ? gold.join(', ') : '-'),
        },
        {
            title: (
                <Tag color='silver'>
                    Silver
                    <CrownOutlined style={{ marginLeft: 8, color: 'white' }} />
                </Tag>
            ),
            dataIndex: 'silver',
            key: 'silver',
            render: (silver) => (silver.length > 0 ? silver.join(', ') : '-'),
        },
        {
            title: (
                <Tag color='brown'>
                    Bronze
                    <CrownOutlined style={{ marginLeft: 8, color: 'white' }} />
                </Tag>
            ),
            dataIndex: 'bronze',
            key: 'bronze',
            render: (bronze) => (bronze.length > 0 ? bronze.join(', ') : '-'),
        },
    ];

    return (
        <Modal
            title="Medal Winners"
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
        >
            {dataSource.length > 0 ? (
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    scroll={{ x: true }}
                />
            ) : (
                <p>No medal winners</p>
            )}
        </Modal>
    );
};

export default MedalWinnersModal;  